import React from 'react';
import Seo from '../components/Seo';

const Home = () => {
  return (
    <>
      <Seo
        title="Nathan Chu"
      />
      <div className="layout-md text-lg space-y-14 my-10">
        <div className="flex flex-col md:flex-row md:items-center md:space-x-8 space-y-8 md:space-y-0">
          <div className="space-y-5 flex-1">
            <p>
              Hi! My name is Nathan. I study at Cornell University, where I am pursuing a B.S. in Computer Science.
            </p>
            <p>
              I am interested in distributed systems and systems programming. I'm currently taking a gap year to explore these at Datadog, Databricks, and Google.
            </p>
            <p>
              Some of my other interests include startups, rock climbing, running, and philosophy. Thanks for visiting!
            </p>
          </div>
          <div className="flex-shrink-0">
            <img
              src="/assets/images/profile.jpeg"
              alt="Nathan Chu"
              className="w-64 h-64 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
